export default __webpack_public_path__ + "static/media/Logo_Solar PV.349127bc.svg";